import type { FundraisingFormRef } from '~/libs/fundraisingErrorReport'

/** The form on this page, for logs: a Drupal form id (`donation-sv-kyka-7f3k`) or `cf:<slug>`, and the document's language. */
export const useFundraisingForm = () =>
  useState<FundraisingFormRef>('fundraising-form', () => ({ formId: '', formLang: '' }))
